import { createContext, useContext, useMemo, useState } from 'react';

const GlobalErrorContext = createContext(null);

export function GlobalErrorProvider({ children }) {
  const [error, setError] = useState(null);
  const value = useMemo(() => ({ error, setError }), [error]);

  return <GlobalErrorContext value={value}>{children}</GlobalErrorContext>;
}

export function useGlobalError() {
  const context = useContext(GlobalErrorContext);
  if (!context) {
    throw new Error('useGlobalError must be used within GlobalErrorProvider');
  }
  return context;
}
